export class authCredentials {
    constructor(username, password) {
        this.username = username;
        this.password = password;
    }
}